import Cookie from "js-cookie";
import { isString } from "lodash";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export const get_ref_id = () =>
  urlParams.get("ref_id") || Cookie.get("ref_id") || "";
export const get_cellxpert_aff_id = () =>
  urlParams.get("affid") || Cookie.get("affid") || "";
export const get_cellxpert_token = () =>
  urlParams.get("cxd") || Cookie.get("cxd") || "";
